/**
 * 时间显示统一转换为北京时间(UTC+8),对应产品文档里"所有时间显示均按北京
 * 时间"的要求。后端所有时间字段落库时都是 UTC ISO 字符串(如
 * "2026-07-12T14:28:46.745099+00:00"),不在后端转换时区(便于后端内部
 * 统一用 UTC 做日期比较、排序),只在前端展示层做一次性转换成北京时间。
 */

const BEIJING_TIME_ZONE = "Asia/Shanghai";

/**
 * 将 ISO 8601 时间字符串(通常是 UTC)格式化为北京时间的
 * "YYYY-MM-DD HH:mm:ss" 字符串。传入空值/无法解析的值时返回 "-"。
 */
export function formatBeijingTime(iso?: string | null): string {
  if (!iso) return "-";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;

  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: BEIJING_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).formatToParts(date);

  const get = (type: string) => parts.find((p) => p.type === type)?.value ?? "";
  // en-CA 的 DateTimeFormat 天然按 YYYY-MM-DD 顺序输出日期部分,拼接更可控,
  // 不依赖某个语言环境的分隔符习惯(避免不同运行环境下 "/" 还是 "-" 不一致)。
  return `${get("year")}-${get("month")}-${get("day")} ${get("hour")}:${get("minute")}:${get("second")}`;
}

/** 仅取北京时间的日期部分(YYYY-MM-DD),用于只需要日期不需要时间的场景。 */
export function formatBeijingDate(iso?: string | null): string {
  if (!iso) return "-";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;

  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: BEIJING_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  const get = (type: string) => parts.find((p) => p.type === type)?.value ?? "";
  return `${get("year")}-${get("month")}-${get("day")}`;
}
